import { CandidateType } from '../features/candidates/Candidates.types';
import { useGetFetch } from '../utils/reactQuery';
import { ApiRoutesEnum } from '../utils/routes';

export type FetchCandidatesResponseType = {
  count: number;
  results: CandidateType[];
};

export const useGetCandidateStorageFile = (idCandidate: string, token: string) => {
  const url = `${ApiRoutesEnum.fileStorage}/${idCandidate}?disposition=attachment&token=${token}`;
  return useGetFetch<Blob>({ url, params: { responseType: 'blob' }, config: { enabled: !!idCandidate && !!token } });
};
